const DEVICE_ID_KEY = 'clientDeviceId'

function createDeviceId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `dev-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
}

/** 浏览器持久化设备 ID，用于云岗亭单设备会话 */
export function getClientDeviceId(): string {
  if (typeof window === 'undefined') return ''
  try {
    const stored = window.localStorage.getItem(DEVICE_ID_KEY)?.trim()
    if (stored) return stored
    const next = createDeviceId()
    window.localStorage.setItem(DEVICE_ID_KEY, next)
    return next
  } catch {
    return createDeviceId()
  }
}
